import React from 'react';
import { useTranslation } from 'react-i18next';
import Logo from '../../assets/logo.svg';

const ClassmedInvalidLink = () => {
  const { t } = useTranslation();

  return (
    <div className="t-h-[100dvh] t-flex t-flex-col t-bg-surface t-font-sans t-text-navy t-overflow-hidden">
      <div className="t-z-[100] t-bg-surface/[.95] t-backdrop-blur-[14px] t-border-b t-border-g200">
        <div className="t-flex t-items-center t-justify-center t-px-4 t-pt-2.5 t-pb-2 t-relative t-min-h-[46px]">
          <img src={Logo} alt="" width={90} height={90} className="t-mx-auto" />
        </div>
      </div>

      <main className="t-flex-1 t-min-h-0 t-flex t-items-center t-justify-center t-px-5">
        <div className="t-w-full t-max-w-[460px] t-text-center">
          <h1 className="!t-m-0 t-font-serif t-text-3xl t-font-normal">{t('Classmed_InvalidLinkTitle')}</h1>
          <p className="!t-mt-3 !t-mb-0 t-text-base t-leading-7 t-text-navy/70">
            {t('Classmed_InvalidLinkBody')}
          </p>
        </div>
      </main>
    </div>
  );
};

export default ClassmedInvalidLink;
